var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',[_c('h5',[_vm._v("Total Audiencia "+_vm._s(_vm.audienceSize))])]),_vm._v(" "),_c('b-col',[_c('h5',[_vm._v("Cobertura "+_vm._s(_vm.coverage)+" ("+_vm._s(Math.round(_vm.coveragePercentaje, 2))+"%)")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }